<template lang="pug">
UiDataTableTr
  UiDataTableTd(v-for="header in headers")
    template(v-if="header.key === 'key'")
      UiFormGroup(:vuelidateModel="v$.item.key")
        UiInput(
          :modelValue="item.key"
          @update:modelValue="item.key = clearPrintCodeKey($event)"
          maxlength="10"
          size="sm"
          :error="v$.item.key.$error"
        )
    template(v-if="languages.includes(header.key)")
      UiFormGroup(:vuelidateModel="v$.item[header.key]")
        UiInput(
          multiline
          v-model="item[header.key]"
          maxlength="512"
          size="sm"
          :error="v$.item[header.key].$error"
        )
    template(v-if="header.key === 'actions'")
      UiButton(
        variant="smooth-danger"
        size="sm"
        @click="$emit('delete')"
        icon="Trash"
      ) {{ $t("actions.delete") }}
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["delete"],

  props: {
    headers: {
      default: null,
    },
    languages: {
      default: null,
    },
    items: {
      default: null,
    },
    item: {
      type: Object,
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    const item = {
      key: {
        required,
        scopePrintCodesDuplicateRule: helpers.withMessage(
          "Key duplicate",
          (value) =>
            !this.items.some((i) => i !== this.item && i.key === value),
        ),
      },
    };

    this.languages.forEach((language) => {
      item[language] = {
        required,
      };
    });

    return { item };
  },

  methods: {
    clearPrintCodeKey(value) {
      return value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    },
  },
});
</script>
